import Vue from 'vue'

import Router from 'vue-router';
import Home from '@/containers/Home';
import goldApple from '@/containers/GoldApple';
import honey from '@/containers/Honey';
import redBerries from '@/containers/RedBerries';
import roseApple from '@/containers/RoseApple';

import Politics from '@/components/Politics'
import Cookies from '@/components/Cookies'
import Terms from '@/components/Terms'

import bannerHome from '@/components/Banner'
import mobileFlavors from '@/components/Flavors'
import recetario from '@/components/RecipeBook'
import mobileRetailers from '@/components/MobileRetailersM'
import retailers from '@/components/Retailers'

import maridajeGold from '@/components/GoldApple/MaridajeGold'
import ritualGold from '@/components/GoldApple/RitualGold'
import dritualGold from '@/components/GoldApple/D_RitualGold'
import bannerGold from '@/components/GoldApple/BannerGold'
import mixologiaGold from '@/components/GoldApple/MixologiaGold'
import dmixologiaGold from '@/components/GoldApple/D_MixologiaGold'
import othersGold from '@/components/GoldApple/OthersGold'

import bannerRed from '@/components/RedBerries/BannerRed'
import ritualRed from '@/components/RedBerries/RitualRed'
import dritualRed from '@/components/RedBerries/D_RitualRed'
import mixologiaRed from '@/components/RedBerries/MixologiaRed'
import dmixologiaRed from '@/components/RedBerries/D_MixologiaRed'
import maridajeRed from '@/components/RedBerries/MaridajeRed'
import othersRed from '@/components/RedBerries/OthersRed'

import maridajeHoney from '@/components/Honey/MaridajeHoney'
import ritualHoney from '@/components/Honey/RitualHoney'
import dritualHoney from '@/components/Honey/D_RitualHoney'
import bannerHoney from '@/components/Honey/BannerHoney'
import mixologiaHoney from '@/components/Honey/MixologiaHoney'
import dmixologiaHoney from '@/components/Honey/D_MixologiaHoney'
import othersHoney from '@/components/Honey/OthersHoney'

import bannerRose from '@/components/RoseApple/BannerRose'
import ritualRose from '@/components/RoseApple/RitualRose'
import dritualRose from '@/components/RoseApple/D_RitualRose'
import mixologiaRose from '@/components/RoseApple/MixologiaRose'
import dmixologiaRose from '@/components/RoseApple/D_MixologiaRose'
import maridajeRose from '@/components/RoseApple/MaridajeRose'
import othersRose from '@/components/RoseApple/OthersRose'

import VueObserveVisibility from 'vue-observe-visibility'
import VueScrollTo from 'vue-scrollto'

Vue.use(Router)
Vue.use(VueObserveVisibility)
Vue.use(VueScrollTo)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/goldApple',
      component: goldApple,
      children: [
        {
          path: '',
          name: 'goldApple',
          components: {
            maridajeGold,
            ritualGold,
            bannerGold,
            mixologiaGold,
            othersGold,
            dritualGold,
            dmixologiaGold
          }
        },
        {
          path: 'ritual',
          name: 'ritualGold',
          components: {
            maridajeGold,
            ritualGold,
            bannerGold,
            mixologiaGold,
            othersGold,
            dritualGold,
            dmixologiaGold
          }
        },
        {
          path: 'mixologia',
          name: 'mixologiaGold',
          components: {
            maridajeGold,
            ritualGold,
            bannerGold,
            mixologiaGold,
            othersGold,
            dritualGold,
            dmixologiaGold
          }
        },
        {
          path: 'maridaje',
          name: 'maridajeGold',
          components: {
            maridajeGold,
            ritualGold,
            bannerGold,
            mixologiaGold,
            othersGold,
            dritualGold,
            dmixologiaGold
          }
        }
      ], 
    },

    {
      path: '/honey',
      component: honey,
      children: [
        {
          path: '',
          name: 'honey',
          components: {
            maridajeHoney,
            ritualHoney,
            bannerHoney,
            mixologiaHoney,
            othersHoney,
            dritualHoney,
            dmixologiaHoney
          }
        },
        {
          path: 'ritual',
          name: 'ritualHoney',
          components: {
            maridajeHoney,
            ritualHoney,
            bannerHoney,
            mixologiaHoney,
            othersHoney,
            dritualHoney,
            dmixologiaHoney
          }
        },
        {
          path: 'mixologia',
          name: 'mixologiaHoney',
          components: {
            maridajeHoney,
            ritualHoney,
            bannerHoney,
            mixologiaHoney,
            othersHoney,
            dritualHoney,
            dmixologiaHoney
          }
        },
        {
          path: 'maridaje',
          name: 'maridajeHoney',
          components: {
            maridajeHoney,
            ritualHoney,
            bannerHoney,
            mixologiaHoney,
            othersHoney,
            dritualHoney,
            dmixologiaHoney
          }
        },
      ],
    },

    {
      path: '/redBerries',
      component: redBerries,
      children: [
        {
          path: '',
          name: 'redBerries',
          components: {
            bannerRed,
            ritualRed,
            mixologiaRed,
            maridajeRed,
            othersRed,
            dritualRed,
            dmixologiaRed
          },
        },
        {
          path: 'ritual',
          name: 'ritualRed',
          components: {
            bannerRed,
            ritualRed,
            mixologiaRed,
            maridajeRed,
            othersRed,
            dritualRed,
            dmixologiaRed
          }
        },
        {
          path: 'mixologia',
          name: 'mixologiaRed',
          components: {
            bannerRed,
            ritualRed,
            mixologiaRed,
            maridajeRed,
            othersRed,
            dritualRed,
            dmixologiaRed
          }
        },
        {
          path: 'maridaje',
          name: 'maridajeRed',
          components: {
            bannerRed,
            ritualRed,
            mixologiaRed,
            maridajeRed,
            othersRed,
            dritualRed,
            dmixologiaRed
          }
        }
      ],
    },

    {
      path: '/roseApple',
      component: roseApple,
      children: [
        {
          path: '',
          name: 'roseApple',
          components: {
            bannerRose,
            ritualRose,
            mixologiaRose,
            maridajeRose,
            othersRose,
            dritualRose,
            dmixologiaRose
          }
        },
        {
          path: 'ritual',
          name: 'ritualRose',
          components: {
            bannerRose,
            ritualRose,
            mixologiaRose,
            maridajeRose,
            othersRose,
            dritualRose,
            dmixologiaRose
          }
        },
        {
          path: 'mixologia',
          name: 'mixologiaRose',
          components: {
            bannerRose,
            ritualRose,
            mixologiaRose,
            maridajeRose,
            othersRose,
            dritualRose,
            dmixologiaRose
          }
        },
        {
          path: 'maridaje',
          name: 'maridajeRose',
          components: {
            bannerRose,
            ritualRose,
            mixologiaRose,
            maridajeRose,
            othersRose,
            dritualRose,
            dmixologiaRose
          }
        }
      ],
    },
    
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '',
          name: 'home',
          components: {
            bannerHome,
            mobileRetailers,
            mobileFlavors,
            retailers,
            recetario
          }
        },
        {
          path: 'flavors',
          name: 'flavors',
          components: {
            bannerHome,
            mobileRetailers,
            mobileFlavors,
            retailers,
            recetario
          }
        },
        {
          path: 'recetario',
          name: 'recetario',
          components: {
            bannerHome,
            mobileRetailers,
            mobileFlavors,
            retailers,
            recetario
          }
        },
        {
          path: 'retailers',
          name: 'retailers',
          components: {
            bannerHome,
            mobileRetailers,
            mobileFlavors,
            retailers,
            recetario
          }
        }, 
      ]
    },

    {
      path: '/politics',
      name: 'politics',
      component: Politics,
    },

    {
      path: '/cookies',
      name: 'cookies',
      component: Cookies,
    },
    {
      path: '/tycos',
      name: 'tycos',
      component: Terms,
    },
    {
      path: '*',
      name: 'Routes',
      components: {
        default: Home,
      },
    },
  ],
})
